import type { ComponentPropsWithoutRef } from 'react';
import { cx } from '../../utils/cx';
import s from './ActionBar.module.css';

export type ActionBarProps = ComponentPropsWithoutRef<'div'> & {
  /** Render inline (not sticky) from this breakpoint up. Default: always sticky. */
  inlineFrom?: 'md' | 'lg';
  /** Sit above the bottom nav instead of at the very bottom of the screen. */
  aboveBottomNav?: boolean;
};

/** The standard home for a screen's primary action on mobile: sticky, in thumb reach, safe-area aware. */
export function ActionBar({ inlineFrom, aboveBottomNav, className, ...rest }: ActionBarProps) {
  return (
    <div
      className={cx(s.bar, className)}
      data-inline-from={inlineFrom}
      data-above-nav={aboveBottomNav || undefined}
      {...rest}
    />
  );
}
